interface GeoLocation {
  x: number;
  y: number;
}

export interface CelebrationJobLocation {
  celebrationJobLocationId?: string; // ID do celebrationJobLocation para buscar staff
  locationUuid: string;
  name: string;
  description: string;
  geoLocation: GeoLocation | null;
  activeStaff: number;
  scheduledStaff: number;
  maxStaff: number;
  minStaff: number;
  priority: number;
  defaultJobTimeInMinutes: number;
}

// Novo modelo para Event (dados simplificados do backend)
export interface Event {
  uuid: string;
  name: string;
  observation: string;
  startAt: string;
  endAt: string;
}

// Modelo para Celebration (dados detalhados para jobs)
export interface Celebration {
  celebrationUuid: string;
  name: string;
  observation: string;
  startAt: string;
  endAt: string;
  activeStaff: number;
  scheduledStaff: number;
  maxStaff: number;
  minStaff: number;
  jobList: CelebrationJob[];
}

export interface CelebrationJob {
  uuid: string;
  name: string;
  description: string;
  locationList: CelebrationJobLocation[];
  activeStaff: number;
  scheduledStaff: number;
  maxStaff: number;
  minStaff: number;
}

// Enum para tipos de eventos do staff
export enum StaffEventTypeEnum {
  END_SUCCESS = 'end_success',
  START = 'start',
  SCHEDULED = 'scheduled'
}

// Interfaces para o Staff Manager
export interface StaffEventType {
  name: string;
  description: string;
  eventTypeEnum: StaffEventTypeEnum;
}

export interface StaffMember {
  id: string;
  cpf: string;
  numeroSistema: number;
  nomeColete: string;
  nomeCompleto: string;
  comandoRegional: string;
  regional: string;
  divisao: string;
  cargo: string;
  telefoneCelular: string;
  erro: string | null;
}

export interface StaffCurrentEvent {
  uuid: string;
  createdAt: string;
  eventType: StaffEventType;
  description: string;
  doneBy: {
    username: string;
    name: string;
  };
}

export interface Staff {
  uuid: string;
  createdAt: string;
  member: StaffMember;
  currentEvent: StaffCurrentEvent;
  startAt: string;
  endAt: string | null;
}

export interface CelebrationLocation {
  uuid: string;
  createdAt: string;
  name: string;
  description: string;
  shortKey: string;
  celebrationLocation: string;
  celebrationJobLocationList: string[];
  geoLocation: GeoLocation;
  printTicketLocation: string;
}

export interface Job {
  uuid: string;
  createdAt: string;
  name: string;
  description: string;
  shortKey: string;
  printTicketJob: string;
}

export interface StaffLocationDetail {
  uuid: string;
  createdAt: string;
  celebration: {
    uuid: string;
    createdAt: string;
    name: string;
    observation: string;
    shortKey: string;
    startAt: string;
    endAt: string;
    locationList: CelebrationLocation[];
    celebrationJobLocationList: string[];
    printTicketCelebration: string;
  };
  location: CelebrationLocation;
  job: Job;
  staffMin: number;
  staffMax: number;
  staffMid: number;
  priority: number;
  defaultJobTimeInMinutes: number;
  staffList: Staff[];
}
